const ICON_PATHS = [
    '/favicon.ico',
    '/icon.svg',
    '/apple-touch-icon.png',
    '/manifest.webmanifest',
    '/icon-192.png',
    '/icon-512.png',
    '/ciox-is-now-datavant.svg',
    '/hi-trust.svg',
    '/soc-2-type-ii.svg',
];

export const NO_AUTH_REQUIRED_PATH_PREFIXES = [
    ...ICON_PATHS,
    '/_next',
    '/rm-basic/dv-logo.png',
    '/rm-basic/rm-intro-thumbnail.png',
    '/rm-basic/rm-intro.mp4',
    '/rm-basic/rm-tutorial-thumbnail.png',
    '/rm-basic/rm-basic-tutorial.mp4',
    '/onboarding',
    '/provider/upload',
    '/api/healthcheck',
    '/api/health-system-implementation/health-check',
    '/api/trpc/cfProxy.validateCioxCreds',
    '/api/trpc/requestManager.rmBasic.getTenantsAssociatedToOutreach',
    '/api/trpc/tenant.getUsers',
    '/api/slack',
    '/api/rm-basic/table',
    '/api/trpc/requestManager.rmBasic.persistIndividualFileUpload',
    '/api/trpc/requestManager.rmBasic.getRMBasicUser',
    '/api/trpc/requestManager.rmBasic.getPresignedUploadUrl',
    '/api/trpc/requestManager.rmBasic.getBulkUploadsByOutreachId',
    '/api/trpc/requestManager.rmBasic.persistBulkUploadByOutreachId',
    '/api/trpc/requestManager.rmBasic.updateChartStatusNoChart',
    '/api/trpc/requestManager.rmBasic.marketingStats',
    '/api/trpc/requestManager.rmBasic.optOutRMStandard',
    '/api/trpc/session.createUserSession',
    '/api/trpc/tenant.doesUserExist',
    '/api/trpc/tenant.createNewUser',
    '/api/trpc/session.getOrCreateDeviceSession',
    '/api/trpc/portal.getOrCreateDeviceSession',
    '/login',
    '/provider/login',
    '/cb',
    '/unauthorized',
    '/error',
    '/logout',
    '/provider-package-review',
    '/api/provider-package-review/session',
    '/api/trpc/payerRetrievalManagementRouter.getProviderPackage',
    '/api/trpc/payerRetrievalManagementRouter.hiomUpdateProviderPackageStatus',
];
